import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import InfoIcon from '@mui/icons-material/InfoRounded';
import { Money } from '../../Money';


const useStyles = makeStyles()(theme => ({
  warning: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.action.disabled,
  },
  moneyMinWidth: {
    minWidth: '48px', // about the size of 5 characters ($xxxx) - needed to align the info icons
  },
  warningIcon: {
    color: theme.palette.info.main,
    marginRight: theme.spacing(1),
  }
}));

export type TableCellMoneyProps = {
  value?: number;
  row: { hasCalculationsWarning?: boolean };
  // useful when the cell is aligned right and you need the info icons to be aligned
  alignInfoIcons?: boolean;
};


export const TableCellMoney: React.VFC<TableCellMoneyProps> = ({ value, row, alignInfoIcons }) => {
  const { classes, cx } = useStyles();

  if (typeof value === 'number' || typeof value === 'string') {
    if (row.hasCalculationsWarning) {
      return (
        <Box className={classes.warning}>
          <InfoIcon className={classes.warningIcon} />
          <span className={cx({ [classes.moneyMinWidth]: alignInfoIcons })}>
            <Money value={value} />
          </span>
        </Box>
      );
    }

    return (
      <span>
        <Money value={value} />
      </span>
    );
  }

  return null;
};
